import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { QuotationComponent } from '../../../quotation/quotation.component';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { GetQuotationPDF } from '../../../../shared/models/quotation-model/main/get-Quotation-Pdf.model';

@Component({
  selector: 'app-quotation-pdf-viewer',
  templateUrl: './quotation-pdf-viewer.component.html',
  styleUrls: ['./quotation-pdf-viewer.component.scss'],
  standalone: true,
  imports: [TranslateModule, CommonModule],
})
export class QuotationPdfViewerComponent implements OnInit {
  getquotationPDF!: GetQuotationPDF;
  pdfSrc: any;
  tempBlob!: Blob;
  urlBlob: any;
  pdfRendered: boolean = false;
  phaseId: number = 73;
  activityId: number = 73;
  agreementId: number = 11;
  attachmentFieldId: number = 2627;
  ticketId: number;
  localAttachmentFieldId!: number;

  constructor(
    public dialogRef: MatDialogRef<QuotationComponent>,
    @Inject(MAT_DIALOG_DATA) public obj: any,
  ) {
    this.ticketId = this.obj.ticketId;
    if (this.obj.hasAttachDocument != undefined && this.obj.hasAttachDocument == true) {
      this.localAttachmentFieldId = this.attachmentFieldId;
    }
  }

  ngOnInit(): void {}

  onClose() {
    this.dialogRef.close();
  }
}
